import React from 'react'
import { Tabs, Tab, Box, createTheme, Switch, IconButton, Divider, Modal } from '@mui/material';
import { useState } from 'react';
import { Button, Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import applicant from '../../images/profilePhoto.png';
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import Edit from '../../images/Edit.svg'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { styled } from '@mui/system';
import Upload from '../../images/portfolio.svg'
import SearchIcon from '@mui/icons-material/Search';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InputStyle from '../../assets/InputStyle';
import ChangePassword from './SignUp Dialog/ChangePassword';
import ProfileCard from '../Profile/ProfileCard';
import CandidateCard from '../../assets/cards/CandidateCard';
import { updateJob } from '../../actions/userAuth';
import { enqueueSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';

function History() {
    const [search, setSearch] = useState("");
    const [open, setOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const dispatch = useDispatch();
    const [jobs, setJobs] = useState([]);

    const handleChange = (index) => {
        var temp = [...jobs];
        temp[index].isActive = !temp[index].isActive;
        dispatch(updateJob(temp[index]._id, temp[index], {}, (data) => {
            console.log(data);
            enqueueSnackbar("Status updated successfully", { variant: 'success' });
            setJobs(temp);
        }, (err) => {
            enqueueSnackbar("Error Occrred! Please try again", { variant: 'error' });
        }))
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = () => {
        // Perform the necessary actions on form submission
        // You can access the form data here and handle it as needed
        // For example, you can save the data to a database, update state, etc.
        handleClose();
    };


    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        // Perform upload logic here
        console.log('Uploaded file:', file);
    };



    return (
        <Layout>
            <UserLayout userRole={"employer"} >
                <Grid container mt={8}>
                    <Grid item md={8}>
                        <Typography className="heading1bold">
                            History
                        </Typography>
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            sx={{
                                background: '#F8FAFF',
                                boxShadow: '0px 23.48060417175293px 46.96120834350586px -8.80522632598877px #3665D014',
                                width:'100%',
                            }}
                            variant="outlined"
                            size="small"
                            placeholder="Search"
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                            }}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </Grid>
                </Grid>

                <Grid container my={2} >
                <Grid item md={3} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                    <Typography className='text2Bold'>Filter</Typography>
                    <select
                        style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                        className='profile-skills-box text2Light'

                        value={selectedOption}
                        onChange={handleChange}
                    >
                        <option value="">Status</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                    </select>
                </Grid>
                <Grid item md={7}></Grid>

                <Grid item md={2} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                    <select
                        style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                        className='profile-skills-box text2Light'
                        value={selectedOption}
                        onChange={handleChange}
                    >
                        <option disabled value="">
                            Sort by date
                        </option>
                        <option value="">None</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                    </select>
                </Grid>
            </Grid >

                <Grid container spacing={2} mt={2}>
                    <Grid item md={3} xs={6}>
                      <CandidateCard/>
                    </Grid>
                    <Grid item md={3} xs={6}>
                      <CandidateCard/>
                    </Grid>
                </Grid>
                {/* <ChangePassword open={open} setOpen={setOpen}/> */}

            </UserLayout>
        </Layout >

    )
}

export default History